import { render } from "./eConstructionStats.vue?vue&type=template&id=20218bb6"
import script from "./eConstructionStats.vue?vue&type=script&lang=js"
export * from "./eConstructionStats.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__